var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.2682 10.2776L3.30078 10.2773","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M10.0869 19.46L19.2793 10.2676L10.0869 1.07519","strokeWidth":"2","key":1})]);
}

ArrowRightInline.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
